import React from 'react';

import {ResponsiveImage} from '../util.js';

import shoWall from './images/sho-brick-wall.svg';
import shoWallSmall from './images/sho-brick-wall-small.svg';

export default function() {
    return <>
        <p>It’s well-known that the period of a simple harmonic oscillator (SHO) is independent of its oscillation amplitude.
            But is this the only oscillator for which this holds?</p>

        <p>No. A simple counterexample is the SHO + ‘brick wall’ potential:</p>
        <ResponsiveImage
            desktopSource={shoWall}
            mobileSource={shoWallSmall}
            alt='Right half of a quadratic potential, with a delta function at zero.'
        />
    </>;
}
